<template>
  <div class="jewel-card-description">
    <h2
      class="title"
      itemprop="name"
    >{{ jewel.title }}</h2>
    <p
      class="materials"
      itemprop="material"
    >{{ jewel.material }}</p>
    <div class="details">
      <p
        class="note"
        v-if="jewel.note"
      >{{ jewel.note }}</p>
      <p
        class="vendor-code"
        v-if="jewel.vendor_code"
      >
        Артикул: <span itemprop="sku">{{ jewel.vendor_code }}</span>
      </p>
    </div>
    <div
      v-if="jewel.price"
      itemprop="offers"
      itemscope
      itemtype="http://schema.org/Offer"
    >
      <meta content="Брест" itemprop="eligibleRegion">
      <p class="price">
        <span itemprop="price">{{ jewel.price | priceFormat }}</span>
        <span itemprop="priceCurrency" content="BYN">р</span>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogJewelCardDescription',
  props: ['jewel'],
  data: function () {
    return {}
  },
  filters: {
    priceFormat (value) {
      return value.toFixed(2)
    }
  }
}
</script>

<style scoped lang="scss">
  .jewel-card-description {
    padding: 1em 1em 0 1em;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    @media only print {
      display: block;
      padding: 0;
      width: 50%;
      margin-left: 50%;
    }

    p {
      line-height: normal;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
    .title {
      font-family: "Gotham Pro Regular", $font-stack;
      letter-spacing: normal;
      text-transform: uppercase;
      font-size: 1.33em;
      font-weight: 500;
      margin-bottom: 0.5em;
    }
    .materials {
      font-family: "Gotham Pro Regular", $font-stack;
      text-transform: uppercase;
      margin-bottom: 0.75em;
    }
    .details {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 0 1.25em 0;
      & > p {
        margin: 0 0 0.5em 0;
        &:last-child { margin: 0; }
      }
      & > .note {
        font-family: 'Baskerville Italic', $font-stack;
        .wf-baskervilleitalic-n4-active & { font-size: 1.25em; }
      }
    }
    .price {
      margin-top: auto;
      margin-bottom: 0;
      color: $default-link-color;
      font-family: "Gotham Pro Regular", $font-stack;
      font-size: 1.5em;
      font-weight: bold;

      &:before {
        content: "";
        display: block;
        width: 35px;
        height: 2px;
        margin: 0 auto 0.5em auto;
        background-color: $default-heading-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-card/CatalogJewelCardDescription.vue